export const GET_MY_CIRCLE_LIST_IN_MY_PAGE = 'GET_MY_CIRCLE_LIST_IN_MY_PAGE'


// WEBPACK FOOTER //
// ./src/constants/User/MyPage.js